module.exports = __webpack_public_path__ + "static/media/alexandria.logo.black.e37f97b4.png";